import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "store/Store";

export interface RecoCommentsReducerState {
  commentCounts : Record<string, number>
  initDone : boolean
}

const defaultState : RecoCommentsReducerState = {
  commentCounts : {},
  initDone : false
}

export const recoCommentsSlice = createSlice({
  name : 'recoComments',
  initialState : defaultState,
  reducers : {
    setRecoCommentsCount : (state : RecoCommentsReducerState, action : PayloadAction<Record<string, number>>) => {
      state.commentCounts = action.payload
      state.initDone = true
    },
    resetRecoCommentsCount : (state : RecoCommentsReducerState) => {
      state.commentCounts = {}
      state.initDone = false
    }
  }
})

export const {
  setRecoCommentsCount,
  resetRecoCommentsCount
} = recoCommentsSlice.actions

export const selectRecoCommentsCount = (state : RootState) => state.recoComments.commentCounts
export const selectRecoCommentsInitDone = (state : RootState) => state.recoComments.initDone